// Eon färger
export const EON_RED = '#F11C0A'

// Pass-kategorier och deras färger
export const KATEGORI_FARGER = {
  ordinarie:         { bg: 'transparent', text: '#444',    label: 'Ordinarie' },
  passandring:       { bg: 'transparent', text: '#444',    label: 'Passändring' },   // ingen bakgrund, bara ⭐
  passbyte:          { bg: '#fce4ec',     text: '#ad1457', label: 'Passbyte' },
  semester:          { bg: '#fffde7',     text: '#827717', label: 'Semester' },
  beviljad_semester: { bg: '#fffde7',     text: '#827717', label: 'Beviljad semester' }, // gul bakgrund + grön ✦
  permission:        { bg: '#ffe082',     text: '#6d4c00', label: 'Permission' }, // annan, mer guldig gul än semester
  flex:              { bg: '#ffe082',     text: '#6d4c00', label: 'Flex' }, // samma villkor/färg som permission
  foraldraledighet:          { bg: '#e0f7fa', text: '#00695c', label: 'Föräldraledighet' },
  beviljad_foraldraledighet: { bg: '#e0f7fa', text: '#00695c', label: 'Beviljad föräldraledighet' }, // turkos bakgrund + ✦
  sjukdom:           { bg: '#ede7f6',     text: '#6a1b9a', label: 'Sjukdom' },
  boka_dag:          { bg: '#e3f2fd',     text: '#1565c0', label: 'Boka dag' },
  beredskap:         { bg: '#F11C0A',     text: '#ffffff', label: 'Beredskap' },      // Eon-röd bakgrund
  ledig:             { bg: '#eeeeee',     text: '#777777', label: 'Betald ledig dag' },
  overtid:           { bg: '#fff3e0',     text: '#e65100', label: 'Övertid' },        // orange bakgrund
}

// Avdelningar och deras färger (för inkorg-gruppsvisning)
export const AVDELNING_FARGER = {
  'RN':       '#F11C0A',
  'LN MMÖ':  '#1565c0',
  'LN NKP':  '#2e7d32',
  'DISP MMÖ':'#6a1b9a',
  'DISP NKP':'#e65100',
}

// Bemanningskrav per dag - gamla, generella (används som fallback för
// avdelningar som inte har egna krav definierade ännu, t.ex. DISP/LN NKP)
export const KRAV_VARDAG = [
  { key: 'F/F1', namn: ['F','F1'], label: 'F / F1', need: 2 },
  { key: 'D1',   namn: ['D1','D3'], label: 'D1 / D3', need: 1 },
  { key: 'E/D2', namn: ['E','E1','D2'], label: 'E / E1 / D2', need: 2 },
  { key: 'N',    namn: ['N'], label: 'N',      need: 1 },
]

export const KRAV_HELG = [
  { key: 'F/F1', namn: ['F','F1'], label: 'F / F1', need: 1 },
  { key: 'E/D2', namn: ['E','E1'], label: 'E / E1', need: 1 },
  { key: 'N',    namn: ['N'], label: 'N',      need: 1 },
]

// Avdelningsspecifika bemanningskrav. Finns avdelningen inte med här,
// används KRAV_VARDAG/KRAV_HELG ovan som fallback (se hamtaBemanningskrav).
export const BEMANNINGSKRAV = {
  'RN': {
    vardag: [
      { key: 'F',     namn: ['F'],      label: 'F',      need: 2 },
      { key: 'D1/DS', namn: ['D1','DS'], label: 'D1/DS', need: 1 },
      { key: 'E/D2',  namn: ['E','D2'], label: 'E/D2',   need: 2 },
      { key: 'N',     namn: ['N'],      label: 'N',      need: 1 },
    ],
    helg: [
      { key: 'F', namn: ['F'], label: 'F', need: 1 },
      { key: 'E', namn: ['E'], label: 'E', need: 1 },
      { key: 'N', namn: ['N'], label: 'N', need: 1 },
    ],
  },
  'LN MMÖ': {
    vardag: [
      { key: 'F',     namn: ['F'],      label: 'F',      need: 2 },
      { key: 'D1/DS', namn: ['D1','DS'], label: 'D1/DS', need: 1 },
      { key: 'E/D2',  namn: ['E','D2'], label: 'E/D2',   need: 2 },
      { key: 'N',     namn: ['N'],      label: 'N',      need: 1 },
    ],
    helg: [
      { key: 'F', namn: ['F'], label: 'F', need: 1 },
      { key: 'E', namn: ['E'], label: 'E', need: 1 },
      { key: 'N', namn: ['N'], label: 'N', need: 1 },
    ],
  },
  'DISP': {
    vardag: [
      { key: 'F',  namn: ['F'],  label: 'F',  need: 2 },
      { key: 'E',  namn: ['E'],  label: 'E',  need: 2 },
      { key: 'N',  namn: ['N'],  label: 'N',  need: 1 },
      { key: 'DT', namn: ['DT'], label: 'DT', need: 2 },
      { key: 'DB', namn: ['DB'], label: 'DB', need: 1 },
      { key: 'D4', namn: ['D4'], label: 'D4', need: 1 },
    ],
    helg: [
      { key: 'F', namn: ['F'], label: 'F', need: 1 },
      { key: 'E', namn: ['E'], label: 'E', need: 1 },
      { key: 'N', namn: ['N'], label: 'N', need: 1 },
    ],
  },
  'LN NKP': {
    // NKP har olika krav mån-tor / fredag, och är helt lediga lör-sön -
    // hanteras via perVeckodag istället för den enklare vardag/helg-uppdelningen.
    perVeckodag: (dag) => {
      if (dag >= 1 && dag <= 4) { // måndag-torsdag
        return [
          { key: 'FN', namn: ['FN'], label: 'FN', need: 1 },
          { key: 'FT', namn: ['FT'], label: 'FT', need: 1 },
          { key: 'E1', namn: ['E1'], label: 'E1', need: 1 },
          { key: 'ET', namn: ['ET'], label: 'ET', need: 1 },
          { key: 'DO', namn: ['DO'], label: 'DO', need: 1 },
        ]
      }
      if (dag === 5) { // fredag
        return [
          { key: 'F',  namn: ['F'],  label: 'F',  need: 2 },
          { key: 'D3', namn: ['D3'], label: 'D3', need: 1 },
        ]
      }
      return [] // lördag/söndag - lediga, inga krav
    },
  },
}

// Hämtar rätt krav-lista för en avdelning och ett specifikt datum. Stödjer
// både enkel vardag/helg-uppdelning och (för t.ex. LN NKP) egna krav per
// veckodag via perVeckodag.
export function hamtaBemanningskrav(avdelning, datum) {
  const dag = new Date(datum + 'T00:00:00').getDay() // 0=sön ... 6=lör
  const arHelgDag = dag === 0 || dag === 6
  const perAvdelning = BEMANNINGSKRAV[avdelning]

  if (perAvdelning?.perVeckodag) return perAvdelning.perVeckodag(dag)
  if (perAvdelning) return arHelgDag ? perAvdelning.helg : perAvdelning.vardag
  return arHelgDag ? KRAV_HELG : KRAV_VARDAG
}

// Periodlängder och timmar
export const PERIODER = {
  10: { veckor: 10, timmar: 345 },
  11: { veckor: 11, timmar: 379.5 },
  12: { veckor: 12, timmar: 414 },
}

// Dygnsvila och veckovila (arbetstidslagen)
export const DYGNSVILA_TIMMAR = 11
export const DYGNSVILA_BEREDSKAP_TIMMAR = 8 // gäller om beredskap ligger precis före eller efter vilan
export const VECKOVILA_TIMMAR = 36
export const VECKOVILA_KOMPENSATION_TIMMAR = 72

// Skiftersättning vid passändring (ej passbyte) – beräknas utifrån antal dagars
// förvarning mellan ändringsdatumet och det datum passet faktiskt gäller
export function beraknaSkiftersattning(andradAt, skiftDatum) {
  if (!andradAt || !skiftDatum) return null
  const andrad = new Date(andradAt)
  const skift = new Date(skiftDatum + 'T12:00:00')
  let dagar = Math.floor((skift.setHours(0,0,0,0) - andrad.setHours(0,0,0,0)) / (1000 * 60 * 60 * 24))
  if (dagar < 0) dagar = 0

  if (dagar >= 0 && dagar <= 14)  return { dagar, divisor: 100, text: 'Månadslön/100' }
  if (dagar >= 15 && dagar <= 30) return { dagar, divisor: 200, text: 'Månadslön/200' }
  if (dagar >= 31 && dagar <= 120) return { dagar, divisor: 500, text: 'Månadslön/500' }
  return { dagar, divisor: null, text: 'Ingen ersättning' }
}

// Räknar ut hur många timmar av det NYA passet som ligger UTANFÖR det
// ursprungligen planerade passets tid – dvs. timmar att registrera vid en passändring.
// Tider anges som "HH:MM" eller "HH:MM:SS". Hanterar pass som går över midnatt (t.ex. N-pass).
function tidTillMinuter(tid) {
  if (!tid) return null
  const [h, m] = tid.split(':').map(Number)
  return h * 60 + m
}

export function beraknaRegistreradeTimmar(planStarttid, planSluttid, nyStarttid, nySluttid) {
  const ps = tidTillMinuter(planStarttid)
  let pe = tidTillMinuter(planSluttid)
  const ns = tidTillMinuter(nyStarttid)
  let ne = tidTillMinuter(nySluttid)
  if (ps === null || pe === null || ns === null || ne === null) return null

  if (pe <= ps) pe += 1440   // planerat pass går över midnatt
  if (ne <= ns) ne += 1440   // nytt pass går över midnatt

  const overlapp = Math.max(0, Math.min(pe, ne) - Math.max(ps, ns))
  const nyLangdMin = ne - ns
  const registreratMin = Math.max(0, nyLangdMin - overlapp)

  return Math.round((registreratMin / 60) * 100) / 100 // timmar, avrundat till 2 decimaler
}

// SE, SD, LF osv → semester/ledig ovanpå ett grundpass. Tar bort S/L-prefixet
// så man kan slå upp grundpassets faktiska start-/sluttid (SE finns inte som
// egen rad i passtyper-tabellen, bara E gör).
export function basPassNamn(namn) {
  if (!namn) return namn
  const u = namn.toUpperCase()
  if (u.startsWith('SJ') && u.length > 2) return u.slice(2)
  if ((u.startsWith('S') || u.startsWith('L')) && u.length > 1) return u.slice(1)
  return u
}
